import { Box, Skeleton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import InputField from './InputField'
import { isNilOrEmpty } from 'packages/core'
import { ValidationMessage } from 'packages/eid-ui'
import {
    getDecisionCommentValidationMessage,
    DECISION_COMMENT_MAX_LENGTH,
    DEFAULT_PREDEFINED_COMMENT_OPTION,
} from 'utils'
import PredefinedComments from './PredefinedComments'
import { usePredefinedComment } from 'hooks'
import Button from './Button'

const useStyles = makeStyles({
    precontainer: {
        position: 'relative',
        '& .MuiBox-root': {
            padding: '0 !important',
        },
    },
})
const DecisionComment = (props) => {
    const classes = useStyles({})
    const {
        initialValue = '',
        onBlur,
        onChange = () => {},
        isRejected,
        callApiOnEveryChange,
    } = props
    const { t } = useTranslation()
    const [comment, setComment] = useState(initialValue)
    const [selectedJustification, setSelectedJustification] = useState()
    const { isLoading: loadingPredefined, data: predefinedComments } =
        usePredefinedComment()

    const validationMessage = getDecisionCommentValidationMessage(
        comment,
        isRejected,
    )
    const isError = !isNilOrEmpty(validationMessage)

    const bindInitialValue = (initialValue, returnDefault) => {
        try {
            if (
                initialValue &&
                !selectedJustification &&
                predefinedComments?.length > 0
            ) {
                const initialValueOption = predefinedComments.find(
                    (option) => option.localKeyName === `MyTasks_${comment}`,
                )
                if (!isNilOrEmpty(initialValueOption)) {
                    return {
                        ...initialValueOption,
                        localKeyName: initialValueOption?.localKeyName?.replace(
                            'MyTasks_',
                            '',
                        ),
                    }
                }
                if (returnDefault) {
                    return DEFAULT_PREDEFINED_COMMENT_OPTION
                }
            } else if (selectedJustification) {
                return selectedJustification
            }
        } catch (error) {}
        return undefined
    }

    return (
        <>
            <Box className={classes.precontainer}>
                {loadingPredefined ? (
                    <Skeleton height={20} width="100%" />
                ) : (
                    <PredefinedComments
                        selectedJustification={selectedJustification}
                        setSelectedJustification={setSelectedJustification}
                        initialValue={bindInitialValue(comment, true)}
                        setDecisionComment={(comment) => {
                            if (comment !== 'Common_Other') {
                                setComment(comment)
                                onChange(comment)
                            } else {
                                setComment('')
                            }
                        }}
                    />
                )}
            </Box>
            {(selectedJustification?.name === 'Other' ||
                bindInitialValue(comment, true)?.name === 'Other') && (
                <Box position="relative" marginTop="20px">
                    <InputField
                        value={comment}
                        multiline={true}
                        rows={2}
                        placeholder={t('AddADecisionComment')}
                        onChange={(e) => {
                            setComment(e.target.value)
                            if (!callApiOnEveryChange) onChange(e.target.value)
                        }}
                        onBlur={onBlur}
                        error={isError}
                    />

                    <Box position="absolute" right={2} fontSize="10px">
                        {comment?.length}/{DECISION_COMMENT_MAX_LENGTH}
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: '2rem',
                            float: 'right',
                        }}
                        maxWidth="15%"
                    >
                        {callApiOnEveryChange && (
                            <Button.Submit
                                onClick={() => {
                                    onChange(comment)
                                }}
                                disabled={!comment}
                            >
                                {t('Save')}
                            </Button.Submit>
                        )}
                    </Box>
                </Box>
            )}
            {isError && <ValidationMessage message={validationMessage} />}
        </>
    )
}

export default DecisionComment
